
require(["nhs/views/AmenityResults/Show"]);
